import type { Answer } from "@/components/types";
import AssistantAnswer from "./AssistantAnswer";
import UserQuestionBubble from "../main/UserQuestionBubble";

interface ConversationMessageProps {
  userQuestion: string;
  assistantAnswer: Answer;
  onDocumentClick: (documentId: string) => void;
  isFollowup?: boolean;
}

const ConversationMessage = ({
  userQuestion,
  assistantAnswer,
  onDocumentClick,
  isFollowup = false,
}: ConversationMessageProps) => {
  return (
    <div className="space-y-6">
      {/* User Question - only show for followup messages */}
      <UserQuestionBubble question={userQuestion} isFollowup={isFollowup} />

      {/* Assistant Answer */}
      <AssistantAnswer answer={assistantAnswer} userQuestion={userQuestion} onDocumentClick={onDocumentClick} />
    </div>
  );
};

export default ConversationMessage;
